// extracted by mini-css-extract-plugin
export var label = "_eu-2";
export var slideContainer = "_eu-0";
export var slider = "_eu-1";